import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import ServicesSection from './components/ServicesSection';
import FounderSection from './components/FounderSection';
import ProcessSection from './components/ProcessSection';
import ReasonsSection from './components/ReasonsSection';
import ResultsSection from './components/ResultsSection';
import CompanySection from './components/CompanySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <HeroSection />
      <ProblemsSection />
      <ServicesSection />
      <FounderSection />
      <ProcessSection />
      <ReasonsSection />
      <ResultsSection />
      <CompanySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
